export const COOKIE_AD_SERVER_BROWSER_ID_CONVERSION_NAME = 'asbidc'
export const COOKIE_AD_SERVER_BROWSER_ID_TARGETING_NAME = 'asbidt'
export const COOKIE_AD_SERVER_CAMPAIGN_CODE_NAME = 'as-campaign'
export const COOKIE_AD_SERVER_USER_ID_NAME = 'asuid'

export const COOKIE_ALGOLIA_USER_TOKEN = '_ALGOLIA'

export const COOKIE_AUTH_NAME = 'auth'

export const COOKIE_CROSS_ENGAGE_NAME = 'JSESSIONID'

export const COOKIE_ECONDA_SESSION_ID_NAME = 'emos_jcsid'
export const COOKIE_ECONDA_VISITOR_ID_NAME = 'emos_jcvid'

export const COOKIE_FEATURE_FLAG_NAME = 'feature-flag-cookie'
export const COOKIE_FEATURE_FLAG_USER_TOKEN_NAME = 'feature-flag-user-token'
export const COOKIE_FEATURE_FLAG_TARGETING_NAME = 'feature-flag-targeting'

export const COOKIE_FIRST_IMPRESSION_NAME = 'first-impression'

/**
 * This cookie is used to store the email of the guest user
 * that is trying to log in. This is used to prefill the email
 * field in the login form.
 */
export const COOKIE_GUEST_EMAIL_NAME = 'guest-email'

export const COOKIE_RX_CAMPAIGN_CODE_NAME = 'emos_jckamp'

export const COOKIE_EXPA_NAME = 'expa'
export const COOKIE_FROZEN_EXPA_NAME = 'frozenExpa'

export const COOKIE_OFFLINE_ORDER_COOKIE_FOR_DOCUMENT_RETRIEVAL_KEY = 'OOS'

export const COOKIE_RECOMMENDATION_SESSION_ID_NAME = 'gkasid'

export const COOKIE_NAME_USER_CONSENT = 'usercentrics_consent'
